export const locale = {
    lang: 'en',
    data: {
        'WELCOME': {
            'HELLO': 'Hello, World!'
        }
    }
};
